import { Box } from "@chakra-ui/react";
import { SafeSearchNotice } from "../../../../components/safeSearch/SafeSearchToggleCard";

export function SafeSearchBanner() {
  return (
    <Box mt="16px" mb="8px">
      <SafeSearchNotice />
    </Box>
  );
}
